<template>
  <!--begin::App-->
  <div class="d-flex flex-column flex-root app-root" id="kt_app_root">
    <!--begin::Page-->
    <div class="app-page flex-column flex-column-fluid py-10" id="kt_app_page">
      <div class="header py-5 px-20 mb-10">
        <router-link to="/">
          <img alt="Logo" src="/images/layout/logo-gray-pixel-roads.png" class="h-30px" />
        </router-link>
      </div>
      <div class="col-md-6 mx-md-auto">
        <div class="title-color1">
          <h6 class="title px-4 mx-5">
            <img src="/images/v2/layout/icon-edit.svg" alt="icon edit" class="icon" />
            <span>{{ $t('create_password') }}</span>
          </h6>
        </div>
        <p class="text-center mt-4 fw-500 text-color11">{{ $t('choose_a_password') }}</p>
        <form
          class="default-form my-5"
          @submit.prevent="submit"
        >
        <div class="form-group mb-3">
          <label class="form-label fw-bold">{{ $t('email') }}</label>
          <input
            type="email"
            class="form-control"
            :label="$t('email_address')"
            placeholder="email@email.com.br"
            v-model.trim="$v.form.email.$model"
          />
        </div>

          <div class="form-group mb-3">
            <label class="form-label fw-bold">{{ $t('password') }}</label>
            <input type="password" class="form-control" :placeholder="$t('enter_your_password')" v-model.trim="$v.form.password.$model" autocomplete="new-password" />
          </div>
          <div class="form-group mb-3">
            <label class="form-label fw-bold">{{ $t('confirm_password') }}</label>
            <input type="password" class="form-control" :placeholder="$t('confirm_password')" v-model.trim="$v.form.password_confirmation.$model" autocomplete="new-password" />
          </div>

          <div class="text-center mt-5">
            <Button
              class="btn-color10"
              :loading="loader"
              :disabled="$v.$invalid"
              @click="submit"
            >
              {{ $t('create_password') }}
            </Button>
          </div>
        </form>
      </div>
    </div>
    <!--end::Page-->
    <TheFooter />
  </div>
  <!--end::App-->
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { required, email } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import TheFooter from '@/components/footers/TheFooter'

export default {
  components: {
    Button,
    TheFooter
  },
  data () {
    return {
      form: {
        email: '',
        password: '',
        password_confirmation: '',
        token: this.$route.params.token
      },
      loader: false
    }
  },
  metaInfo () {
    return {
      title: this.$t('change_password')
    }
  },
  validations () {
    return {
      form: {
        email: { required, email },
        password: { required },
        password_confirmation: { required },
        token: { required }
      }
    }
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  },
  methods: {
    async submit () {
      this.loader = true
      try {
        await AuthService.createPassword(this.form)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('password_created_successfully')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$router.push('/')
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
#kt_app_root {
  background-color: #fff;
}

.header {
  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
}
</style>
